<template>
    <!-- 取样值 -->
    <div class="sample h-100">
        <div v-if="sample.length || (probe && probe.length)">
            <el-carousel trigger="click" style="overflow: hidden" height="220px" :autoplay="false"
                :indicator-position="'none'" :arrow="sample.length > 1 ? 'always' : 'never'">
                <!-- 取样值数据 sample -->
                <el-carousel-item v-for="(item, index) in sample" :key="index">
                    <SampleValueTable :sample="item" :carrierTpyeId="typeId" :scopeName="scopeName"
                        :carrierName="carrierName" type="sample" :carrierId="carrierId" :carrierInfo="carrierInfo">
                    </SampleValueTable>
                </el-carousel-item>
                <!-- 实时采集数据 probe -->
                <el-carousel-item v-for="item in probe" :key="item.id">
                    <SampleValueTable :sample="item" :carrierTypeId="typeId" :scopeName="scopeName"
                        :carrierName="carrierName" type="probe" :carrierId="carrierId" :carrierInfo="carrierInfo">
                    </SampleValueTable>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div v-else style="height:100%;" class="border">
            <div class="uk-text-center uk-margin-large-top" style="color:#ccc;font-size: 16px;">{{
                $t('integration.unassociated_device') }}</div>
        </div>
    </div>
</template>

<script>
import SampleValueTable from './SampleValueTable.vue';

export default {
    props: {
        // 取样值,
        sampleValue: {
            type: [Object, String],
            default: ''
        },
        // 探测值
        probeValue: {
            type: [Array, String],
            default: () => {
                return [];
            }
        },
        // 监测点类型 默认1 保温箱
        typeId: {
            type: Number,
            default: 1
        },
        // 客户名称 用于传入历史数据
        scopeName: {},
        // 监测点名称 用于传入历史数据
        carrierName: {},
        carrierId: {},
        carrierInfo: {}
    },
    data() {
        return {
            sample: [],
            probe: null,
            currentSampleValue: null
        };
    },
    watch: {
        // 格式: string | {hum:[],temp:[]}
        sampleValue: {
            immediate: true,
            handler(newVal) {
                if (!newVal) {
                    return
                }

                // 保存当前值
                this.currentSampleValue = newVal

                const keys = Object.keys(newVal)
                if (keys.length === 0) {
                    return
                }

                let parsedData = newVal
                if (typeof newVal === 'string') {
                    try {
                        parsedData = JSON.parse(newVal)
                    } catch (e) {
                        console.error('Failed to parse sampleValue:', e)
                        this.sample = []
                        return
                    }
                }

                if (parsedData.temp instanceof Array || parsedData.hum instanceof Array) {
                    let temp = [];
                    let hum = [];
                    if (parsedData.temp) {
                        temp = parsedData.temp.map(item => {
                            if (!item.code) {
                                item.code = 'temp';
                            }
                            item.type = 'sample';
                            return item;
                        });
                    }
                    if (parsedData.hum) {
                        hum = parsedData.hum.map(item => {
                            if (!item.code) {
                                item.code = 'hum';
                            }
                            item.type = 'sample';
                            return item;
                        });
                    }
                    this.sample = [...temp, ...hum];
                } else {
                    this.sample = [];
                }
            }
        },
        probeValue: {
            immediate: true,
            handler() {
                if (this.probe) return;
                if (!Object.keys(this.probeValue).length) return [];
                if (!(this.probeValue instanceof Array)) {
                    return;
                }

                // 把数据变成取样值的格式 逻辑需要复用
                this.probe = this.probeValue.map(range => {
                    // 过滤掉没有绑定传感器的底座
                    let sensor = range.sensorProbeList.filter(item => {
                        if (item.carrierDeviceCatalog === 4 && item.sensorType === undefined)
                            return false;
                        return true;
                    });

                    // 有探测区间
                    sensor = sensor.map(sensor => {
                        if (typeof sensor.probe === 'string') {
                            sensor.probe = JSON.parse(sensor.probe);
                        }
                        if (sensor.probe) {
                            if (sensor.probe.temp) {
                                sensor = { ...sensor, ...sensor.probe.temp, code: 'temp' };
                            }
                            if (sensor.probe.hum) {
                                sensor = { ...sensor, ...sensor.probe.hum, code: 'hum' };
                            }
                        }
                        sensor.no = sensor.carrierDeviceName;
                        sensor.probe = undefined;
                        sensor.status = sensor.sensorStatus;
                        sensor.type = sensor.sensorType;
                        sensor.catalog = sensor.carrierDeviceCatalog;
                        sensor.id = sensor.carrierDeviceCode;
                        return sensor;
                    });
                    range.sensorProbeList = undefined;
                    range.time = this.$timetransition(new Date().getTime());
                    range.type = 'probe';


                    return { ...range, itemMap: sensor };
                });
            }
        }
    },
    components: {
        SampleValueTable
    }
};
</script>

<style scoped lang="scss">
$border-color: #cccccc;

.sample {
    .height-32 {
        height: 32px;
        line-height: 32px;
    }

    ::v-deep .table-value {
        font-size: 30px;
        font-weight: bolder;
    }

    ::v-deep .middle-height {
        height: 220px;
    }

    ::v-deep .border {
        border: 1px solid $border-color;
    }

    ::v-deep .uk-table {
        margin-bottom: 3px;
    }

    ::v-deep .height-16 {
        height: 16px;
        line-height: 16px;
    }

    ::v-deep .probe {
        margin-top: 3px;
        border: solid 1px #344962;
        text-align: center;
    }

    ::v-deep .el-carousel__arrow {
        background-color: rgba(31, 45, 61, 0.25);

        .el-icon-arrow-right {
            color: white;
        }
    }
}
</style>
